import { Images } from '@/assets/images';
import {
	DocTypeEnum,
	PageTypeEnum,
	REGEX,
	ResidenceEnum,
	ResidenceLabel,
	VisaTimeLabel,
} from '@/constant';
import { cn, convertVisaCodeToName, insertIf, insertObjectIfV2 } from '@/utils';

import { includes } from 'ramda';

import { splitForeignerNoToChars } from '../define-document-write.helper';
import { CheckboxType, FormConfig } from '../define-document-write.type';

export enum SelectApplicationEnum {
	ALIEN_REGISTRATION = 'ALIEN_REGISTRATION',
	REISSUANCE_OF_REGISTRATION_CARD = 'REISSUANCE_OF_REGISTRATION_CARD',
	EXTENSION_OF_SOJOURN_PERIOD = 'EXTENSION_OF_SOJOURN_PERIOD',
	CHANGE_OF_STATUS_OF_SOJOURN = 'CHANGE_OF_STATUS_OF_SOJOURN',
	GRANTING_STATUS_OF_SOJOURN = 'GRANTING_STATUS_OF_SOJOURN',
	ENGAGE_IN_ACTIVITIES_NOT_COVERED_BY_THE_STATUS_OF_SOJOURN = 'ENGAGE_IN_ACTIVITIES_NOT_COVERED_BY_THE_STATUS_OF_SOJOURN',
	CHANGE_OR_ADDITION_OF_WORKPLACE = 'CHANGE_OR_ADDITION_OF_WORKPLACE',
	REENTRY_PERMIT = 'REENTRY_PERMIT',
	ALTERATION_OF_RESIDENCE = 'ALTERATION_OF_RESIDENCE',
	CHANGE_OF_INFORMATION_ON_ALIEN_REGISTRATION = 'CHANGE_OF_INFORMATION_ON_ALIEN_REGISTRATION',
}

export enum SexEnum {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
}

export enum SchoolStatusEnum {
	NON_SCHOOL = 'NonSchool',
	ELEMENTARY = 'Elementary',
	MIDDLE = 'Middle',
	HIGHT = 'Hight',
}

export enum TypeSchoolEnum {
	ACCREDITED = 'Accredited',
	NON_ACCREDITED = 'NonAccredited',
}

export const VISA_CODE_OPTION = [
	{
		id: '',
		value: '',
		label: '선택',
	},
	...Object.entries(ResidenceLabel).map(([key, value], index) => ({
		id: key,
		value: key,
		label: value,
	})),
] as any;

const initializeValue = {
	applicationJobSelection: [] as SelectApplicationEnum[],
	changeStatus: '',
	changeStatusEn: '',
	engageStatus: '',
	engageStatusEn: '',
	grantingStatus: ResidenceEnum.E8,
	appcAlienRegistNo: '',
	appcSchoolStatus: '',
	appcSchoolStatusEn: '',
	typeSchool: '',
	appcRptPassportImg: '',
	surName: '',
	givenName: '',
	chineseName: '',
	YearBirthDate: '',
	MonthBirthDate: '',
	DayBirthDate: '',
	gender: '',
	nationalName: '',
	passportNo: '',
	passportIssueDate: '',
	passportExpiryDate: '',
	appcKoreaAddr: '',
	appcTellPhone: '',
	phone: '',
	city: '',
	appcCellPhone: '',
	appcSchoolName: '',
	appcSchoolPhone: '',
	currentWorkplace: '',
	currentBusinessRegistrationNo: '',
	currentTelephoneNo: '',
	newWorkplace: '',
	newBusinessRegistrationNo: '',
	newTelephoneNo: '',
	appcAnnualIncome: '',
	appcOccupation: '',
	appcIntendedReentry: '',
	appcEmail: '',
	appcRefundBankAccount: '',
	appcRegistDate: '',
	appcFirstEntryDate: '',
	residenceName: '',
	no1: '',
	no2: '',
	no3: '',
	no4: '',
	no5: '',
	no6: '',
	no7: '',
	no8: '',
	no9: '',
	no10: '',
	no11: '',
	no12: '',
	no13: '',
	// DB
	appcEntryDate: '',
	appcDepartureDate: '',

	residenceTime: '',

	appcApplicationDate: '',
	appcReceiptNum: '',
	appcAcceptPermissionDate: '',
	appcPermissionNum: '',
	appcStayStatus: '',
	appcStayPeriod: '',
	payment4: '',
	payment8: '',
	payment: '',
	payment2: '',
	payment3: '',
	payment5: '',
	payment6: '',
	payment7: '',
	position: '',
	revenueExemption: '',
	revenueExemptionReason: '',
	appcSignature: '',
	consentSharing: '',
	consentSharingSignature: '',
	consentSpouseSharing: '',
	consentSpouseSharingSignature: '',
	consentParentSharing: '',
	consentParentSharingSignature: '',
};

type IValues = typeof initializeValue;

export const INTEGRATED_APPLICATION_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '통합신청서',
	mapPropToValues({
		refTableName,
		detailData,
		docType,
		applicantData,
		applicantLodgingData,
		franchiseData,
		secondFranchiseData,
	}) {
		const mappingJobSelection = [
			...insertIf(
				docType === DocTypeEnum.WC1_07,
				SelectApplicationEnum.CHANGE_OR_ADDITION_OF_WORKPLACE
			),

			...insertIf(
				docType === DocTypeEnum.AM1_05,
				SelectApplicationEnum.ALIEN_REGISTRATION
			),

			...insertIf(
				docType === DocTypeEnum.WCF_02,
				SelectApplicationEnum.EXTENSION_OF_SOJOURN_PERIOD
			),

			SelectApplicationEnum.GRANTING_STATUS_OF_SOJOURN,
		];

		const mappingWorkChangePlace = {
			...insertObjectIfV2(refTableName === PageTypeEnum.CHANGE_WORK_PLACE, {
				currentBusinessRegistrationNo:
					detailData?.prevBusinessRegistNo ||
					detailData?.prevCorporateRegistNo ||
					'',
				currentWorkplace: detailData?.prevFranchiseName || '',
				currentTelephoneNo: detailData?.prevFranchisePhone || '',
				newBusinessRegistrationNo:
					detailData?.newBusinessRegistNo ||
					detailData?.newCorporateRegistNo ||
					'',
				newWorkplace: detailData?.newFranchiseName || '',
				newTelephoneNo: detailData?.newFranchisePhone || '',
			}),

			...insertObjectIfV2(refTableName === PageTypeEnum.APPLICANT, {
				currentBusinessRegistrationNo:
					franchiseData?.businessRegistNo ||
					franchiseData?.corporateRegistNo ||
					'',
				currentWorkplace: franchiseData?.name || '',
				currentTelephoneNo: franchiseData?.phone || '',
				newBusinessRegistrationNo:
					secondFranchiseData?.businessRegistNo ||
					secondFranchiseData?.corporateRegistNo ||
					'',
				newWorkplace: secondFranchiseData?.name || '',
				newTelephoneNo: secondFranchiseData?.phone || '',
			}),

			...insertObjectIfV2(refTableName === PageTypeEnum.FRANCHISE, {
				currentBusinessRegistrationNo:
					franchiseData?.businessRegistNo ||
					franchiseData?.corporateRegistNo ||
					'',
				currentWorkplace: franchiseData?.name || '',
				currentTelephoneNo: franchiseData?.phone || '',
				newBusinessRegistrationNo:
					secondFranchiseData?.businessRegistNo ||
					secondFranchiseData?.corporateRegistNo ||
					'',
				newWorkplace: secondFranchiseData?.name || '',
				newTelephoneNo: secondFranchiseData?.phone || '',
			}),
		};

		return {
			applicationJobSelection: mappingJobSelection,

			grantingStatus: applicantData?.visaCode || ResidenceEnum.E8,

			appcRptPassportImg: applicantData?.avatarFile || '',
			surName: applicantData?.firstName || '',
			givenName: applicantData?.lastName || '',
			YearBirthDate: applicantData?.birthDate?.split('-')?.[0] || '',
			MonthBirthDate: applicantData?.birthDate?.split('-')?.[1] || '',
			DayBirthDate: applicantData?.birthDate?.split('-')?.[2] || '',
			gender: applicantData?.gender || '',

			nationalName: applicantData?.nationalName || '',
			...splitForeignerNoToChars(applicantData?.foreignerNo || ''),
			passportNo: applicantData?.passportNo || '',
			passportIssueDate: applicantData?.passportIssueDate || '',
			passportExpiryDate: applicantData?.passportExpireDate || '',
			appcKoreaAddr: applicantLodgingData?.lodgingAddress || '',
			appcTellPhone: applicantData?.phone || '',
			phone: applicantData?.phone || '',
			city: applicantData?.hometownAddr || '',
			appcCellPhone: applicantData?.hometownPhone || '',

			// appcEmail: applicantData?.email || '',

			appcFirstEntryDate: applicantData?.entryDate || '',
			residenceName: convertVisaCodeToName(applicantData?.visaCode) || '',
			residenceTime: VisaTimeLabel[applicantData?.visaTime] || '',

			consentSharing: applicantData?.fullName || '',

			...mappingWorkChangePlace,
		};
	},

	pages: [
		{
			background: {
				src: Images.integratedApplicationHighlight,
				className: 'template',
				dataSource: Images.integratedApplication,
			},
			textAreas: [
				(data, index) => ({
					name: 'engageStatus',
					maxHeight: 17,
					maxLength: 4,
					containerClassName: cn(
						'absolute top-[153px] left-[485px] w-[37px]',
						!includes(
							SelectApplicationEnum.ENGAGE_IN_ACTIVITIES_NOT_COVERED_BY_THE_STATUS_OF_SOJOURN,
							data?.applicationJobSelection
						) && 'invisible'
					),
				}),
				(data, index) => ({
					name: 'engageStatus',
					maxHeight: 17,
					maxLength: 4,
					containerClassName: cn(
						'absolute top-[183px] left-[475px] w-[37px]',
						!includes(
							SelectApplicationEnum.ENGAGE_IN_ACTIVITIES_NOT_COVERED_BY_THE_STATUS_OF_SOJOURN,
							data?.applicationJobSelection
						) && 'invisible'
					),
				}),
				(data, index) => ({
					name: 'changeStatus',
					maxHeight: 17,
					maxLength: 4,
					containerClassName: cn(
						'absolute top-[262px] left-[250px] w-[31px]',
						!includes(
							SelectApplicationEnum.CHANGE_OF_STATUS_OF_SOJOURN,
							data?.applicationJobSelection
						) && 'invisible'
					),
				}),
				(data, index) => ({
					name: 'changeStatus',
					maxHeight: 17,
					maxLength: 4,
					containerClassName: cn(
						'absolute top-[291px] left-[210px] w-[31px]',
						!includes(
							SelectApplicationEnum.CHANGE_OF_STATUS_OF_SOJOURN,
							data?.applicationJobSelection
						) && 'invisible'
					),
				}),

				{
					name: 'surName',
					maxHeight: 17,
					maxLength: 20,
					containerClassName: 'absolute top-[376px] left-[168px] w-[187px]',
				},
				{
					name: 'givenName',
					maxHeight: 17,
					maxLength: 50,
					containerClassName: 'absolute top-[376px] left-[358px] w-[360px]',
				},
				{
					name: 'YearBirthDate',
					maxHeight: 17,
					maxLength: 4,
					containerClassName: 'absolute top-[411px] left-[195px] w-[105px]',
				},
				{
					name: 'MonthBirthDate',
					maxHeight: 17,
					maxLength: 2,
					containerClassName: 'absolute top-[411px] left-[303px] w-[50px]',
				},
				{
					name: 'DayBirthDate',
					maxHeight: 17,
					maxLength: 2,
					containerClassName: 'absolute top-[411px] left-[357px] w-[50px]',
				},
				{
					name: 'nationalName',
					maxHeight: 60,
					maxLength: 30,
					containerClassName:
						'absolute top-[395px] left-[640px] w-[78px] leading-[12px]',
				},
				{
					name: 'no1',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[249px] w-[24px]',
				},
				{
					name: 'no2',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[275px] w-[24px]',
				},
				{
					name: 'no3',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[303px] w-[24px]',
				},
				{
					name: 'no4',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[330px] w-[24px]',
				},
				{
					name: 'no5',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[357px] w-[24px]',
				},
				{
					name: 'no6',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[384px] w-[24px]',
				},
				{
					name: 'no7',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[411px] w-[19px]',
				},
				{
					name: 'no8',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[434px] w-[19px]',
				},
				{
					name: 'no9',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[457px] w-[19px]',
				},
				{
					name: 'no10',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[481px] w-[19px]',
				},
				{
					name: 'no11',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[504px] w-[19px]',
				},
				{
					name: 'no12',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[528px] w-[19px]',
				},
				{
					name: 'no13',
					maxHeight: 24,
					maxLength: 1,
					className: 'text-center',
					containerClassName: 'absolute top-[431px] left-[552px] w-[19px]',
				},
				{
					name: 'passportNo',
					maxHeight: 30,
					maxLength: 25,
					containerClassName:
						'absolute top-[456px] left-[170px] w-[129px] leading-[12px]',
				},
				{
					name: 'appcKoreaAddr',
					maxHeight: 30,
					maxLength: 80,
					containerClassName:
						'absolute top-[484px] left-[171px] w-[545px] leading-[12px]',
				},
				{
					name: 'appcTellPhone',
					maxHeight: 14,
					maxLength: 15,
					containerClassName: 'absolute top-[516px] left-[247px] w-[146px]',
				},
				{
					name: 'phone',
					maxHeight: 14,
					maxLength: 15,
					containerClassName: 'absolute top-[516px] left-[557px] w-[146px]',
				},
				{
					name: 'city',
					maxHeight: 30,
					maxLength: 80,
					containerClassName:
						'absolute top-[530px] left-[247px] w-[304px] leading-[12px] ',
				},
				{
					name: 'appcCellPhone',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[530px] left-[645px] w-[72px] leading-[12px]',
				},
				{
					name: 'appcSchoolName',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[558px] left-[485px] w-[67px] leading-[12px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'appcSchoolPhone',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[558px] left-[645px] w-[67px] leading-[12px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'currentWorkplace',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[615px] left-[277px] w-[67px] leading-[12px]',
				},
				{
					name: 'currentBusinessRegistrationNo',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[615px] left-[474px] w-[78px] leading-[12px]',
				},
				{
					name: 'currentTelephoneNo',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[615px] left-[644px] w-[72px] leading-[12px]',
				},
				{
					name: 'newWorkplace',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[644px] left-[277px] w-[67px] leading-[12px]',
				},
				{
					name: 'newBusinessRegistrationNo',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[644px] left-[474px] w-[78px] leading-[12px]',
				},
				{
					name: 'newTelephoneNo',
					maxHeight: 30,
					maxLength: 14,
					containerClassName:
						'absolute top-[644px] left-[644px] w-[72px] leading-[12px]',
				},
				{
					name: 'appcAnnualIncome',
					maxHeight: 14,
					maxLength: 8,
					containerClassName: 'absolute top-[675px] left-[277px] w-[72px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'appcOccupation',
					maxHeight: 14,
					maxLength: 8,
					containerClassName: 'absolute top-[675px] left-[645px] w-[70px]',
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'appcIntendedReentry',
					maxHeight: 14,
					maxLength: 8,
					containerClassName: 'absolute top-[695px] left-[277px] w-[70px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'appcEmail',
					maxHeight: 14,
					maxLength: 35,
					containerClassName: 'absolute top-[693px] left-[474px] w-[241px]',
				},
				{
					name: 'appcRefundBankAccount',
					maxHeight: 14,
					maxLength: 30,
					containerClassName: 'absolute top-[712px] left-[476px] w-[241px]',
				},
				{
					name: 'residenceName',
					maxHeight: 14,
					maxLength: 10,
					containerClassName: 'absolute top-[935px] left-[450px] w-[85px]',
				},

				{
					name: 'residenceTime',
					maxHeight: 14,
					maxLength: 10,
					containerClassName: 'absolute top-[935px] left-[630px] w-[85px]',
				},

				{
					name: 'appcReceiptNum',
					maxHeight: 14,
					maxLength: 23,
					containerClassName: 'absolute top-[953px] left-[450px] w-[260px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'appcPermissionNum',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[979px] left-[452px] w-[82px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'appcStayStatus',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[971px] left-[632px] w-[82px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'appcStayPeriod',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[990px] left-[632px] w-[82px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'payment',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1006px] left-[260px] w-[87px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'payment2',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1006px] left-[355px] w-[87px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'payment3',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1006px] left-[449px] w-[87px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'payment5',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1024px] left-[260px] w-[87px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'payment6',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1024px] left-[355px] w-[87px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'payment7',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1024px] left-[449px] w-[87px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'payment4',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1024px] left-[172px] w-[85px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'position',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1006px] left-[667px] w-[60px]',
					regex: REGEX.ALLOW_KR,
				},
				{
					name: 'revenueExemptionReason',
					maxHeight: 14,
					maxLength: 5,
					containerClassName: 'absolute top-[1042px] left-[476px] w-[68px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'consentSharing',
					maxHeight: 32,
					maxLength: 40,
					containerClassName:
						'absolute w-[125px] h-[33px] top-[885px] left-[126px] leading-[10px]',
					className: 'text-[10px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER,
				},
				{
					name: 'consentSpouseSharing',
					maxHeight: 28,
					maxLength: 12,
					containerClassName:
						'absolute w-[70px] h-[33px] top-[887px] left-[366px] leading-[12px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER,
				},
				{
					name: 'consentParentSharing',
					maxHeight: 28,
					maxLength: 8,
					containerClassName:
						'absolute w-[46px] h-[33px] top-[887px] left-[600px] leading-[12px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER,
				},
			],
			checkboxes: [
				// {
				// 	type: CheckboxType.SELECT_ALL,
				// 	name: 'applicationJobSelection',
				// 	className: 'absolute top-[132px] left-[77px]',
				// 	options: Object.values(SelectApplicationEnum),
				// 	getResetKey: () => {
				// 		return [
				// 			'grantingStatus',
				// 			'engageStatus',
				// 			'engageStatusEn',
				// 			'changeStatus',
				// 			'changeStatusEn',
				// 		];
				// 	},
				// 	iconType: 'circle',
				// },
				{
					type: CheckboxType.MULTIPLE,
					name: 'applicationJobSelection',
					classNames: [
						'absolute top-[152px] left-[80px]',
						'absolute top-[199px] left-[80px]',
						'absolute top-[229px] left-[80px]',
						'absolute top-[261px] left-[80px]',
						'absolute top-[309px] left-[80px]',
						'absolute top-[152px] left-[291px]',
						'absolute top-[199px] left-[291px]',
						'absolute top-[229px] left-[291px]',
						'absolute top-[261px] left-[291px]',
						'absolute top-[309px] left-[291px]',
					],
					options: Object.values(SelectApplicationEnum),
					getResetKey: (value: string) => {
						let result: string[] = [];

						if (value === SelectApplicationEnum.GRANTING_STATUS_OF_SOJOURN) {
							result = ['grantingStatus'];
						} else if (
							value ===
							SelectApplicationEnum.ENGAGE_IN_ACTIVITIES_NOT_COVERED_BY_THE_STATUS_OF_SOJOURN
						) {
							result = ['engageStatus', 'engageStatusEn'];
						} else if (
							value === SelectApplicationEnum.CHANGE_OF_STATUS_OF_SOJOURN
						) {
							result = ['changeStatus', 'changeStatusEn'];
						}

						return result;
					},
					iconType: 'circle',
				},
				{
					name: 'gender',
					classNames: [
						'absolute top-[393px] left-[482px]',
						'absolute top-[409px] left-[482px]',
					],
					options: Object.values(SexEnum),
					iconType: 'circle',
				},
				{
					name: 'appcSchoolStatus',
					classNames: [
						'absolute top-[558px] left-[208px]',
						'absolute top-[558px] left-[277px]',
						'absolute top-[558px] left-[325px]',
						'absolute top-[558px] left-[363px]',
					],
					options: Object.values(SchoolStatusEnum),
					iconType: 'circle',
				},
				{
					name: 'appcSchoolStatus',
					classNames: [
						'absolute top-[570px] left-[209px]',
						'absolute top-[570px] left-[278px]',
						'absolute top-[570px] left-[326px]',
						'absolute top-[570px] left-[366px]',
					],
					options: Object.values(SchoolStatusEnum),
					iconType: 'circle',
				},
				{
					name: 'typeSchool',
					classNames: [
						'absolute top-[588px] left-[487px]',
						'absolute top-[588px] left-[668px]',
					],
					options: Object.values(TypeSchoolEnum),
					iconType: 'circle',
				},
				{
					name: 'typeSchool',
					classNames: [
						'absolute top-[599px] left-[485px]',
						'absolute top-[599px] left-[667px]',
					],
					options: Object.values(TypeSchoolEnum),
					iconType: 'circle',
				},
				{
					name: 'revenueExemption',
					classNames: ['absolute top-[1039px] left-[409px]'],
					options: ['0', '1'],
					iconType: 'circle',
				},
				{
					name: 'payment8',
					classNames: [
						'absolute top-[1021px] left-[563px]',
						'absolute top-[1021px] left-[587px]',
					],
					options: ['1', '0'],
					iconType: 'circle',
				},
			],
			selects: [
				(data, index) => ({
					name: 'grantingStatus',
					containerClassName: cn(
						'absolute top-[307px] left-[248px] w-[31px]',
						!includes(
							SelectApplicationEnum.GRANTING_STATUS_OF_SOJOURN,
							data?.applicationJobSelection
						) && 'invisible'
					),
					className: '!leading-[10px] text-[10px]',
					options: VISA_CODE_OPTION,
				}),
				(data, index) => ({
					name: 'grantingStatus',
					maxHeight: 30,
					maxLength: 11,
					containerClassName: cn(
						'absolute top-[337px] left-[210px] w-[31px]',
						!includes(
							SelectApplicationEnum.GRANTING_STATUS_OF_SOJOURN,
							data?.applicationJobSelection
						) && 'invisible'
					),
					className: '!leading-[10px] text-[10px]',
					options: VISA_CODE_OPTION,
				}),
			],
			signatures: [
				{
					name: 'appcSignature',
					className: 'absolute w-[90px] h-[30px] top-[732px] left-[582px]',
				},
				{
					name: 'consentSharingSignature',
					className: 'absolute w-[44px] h-[30px] top-[887px] left-[250px]',
					signatureCanvasProps: {
						minWidth: 3,
						maxWidth: 5,
					},
				},
				{
					name: 'consentSpouseSharingSignature',
					className: 'absolute w-[72px] h-[33px] top-[884px] left-[433px]',
				},
				{
					name: 'consentParentSharingSignature',
					className: 'absolute w-[72px] h-[33px] top-[884px] left-[645px]',
				},
			],
			datePickers: [
				{
					name: 'passportIssueDate',
					className: 'h-[12px] px-1 [&>.ant-picker-input>input]:!text-[12px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[460px] left-[415px]',
				},
				{
					name: 'passportExpiryDate',
					className: 'h-[12px] px-1 [&>.ant-picker-input>input]:!text-[12px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[460px] left-[642px]',
				},
				{
					name: 'appcRegistDate',
					className: 'h-[15px] px-1 [&>.ant-picker-input>input]:!text-[12px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[736px] left-[277px]',
				},
				{
					name: 'appcFirstEntryDate',
					className: 'h-[12px] px-1 [&>.ant-picker-input>input]:!text-[12px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[931px] left-[258px] w-[91px]',
				},
				{
					name: 'appcApplicationDate',
					className: 'h-[12px] px-1 [&>.ant-picker-input>input]:!text-[12px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[949px] left-[258px] w-[91px]',
				},
				{
					name: 'appcAcceptPermissionDate',
					className: 'h-[12px] px-1 [&>.ant-picker-input>input]:!text-[12px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[976px] left-[258px] w-[91px]',
				},
			],
			inputFiles: [
				{
					name: 'appcRptPassportImg',
					className: 'absolute top-[153px] left-[575px] w-[142px] h-[203px]',
					classNameIconDelete: 'right-1.5',
				},
			],
		},
	],
};
